import { render, staticRenderFns } from "./PregnancyCheckup.vue?vue&type=template&id=4099160a&scoped=true&"
import script from "./PregnancyCheckup.vue?vue&type=script&lang=js&"
export * from "./PregnancyCheckup.vue?vue&type=script&lang=js&"
import style0 from "./PregnancyCheckup.vue?vue&type=style&index=0&id=4099160a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099160a",
  null
  
)

export default component.exports